import { render, staticRenderFns } from "./DeclarationBooksComponent.vue?vue&type=template&id=f7b9dd7c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./DeclarationBooksComponent.vue?vue&type=script&lang=js&"
export * from "./DeclarationBooksComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationBooksComponent.vue?vue&type=style&index=0&id=f7b9dd7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b9dd7c",
  null
  
)

component.options.__file = "DeclarationBooksComponent.vue"
export default component.exports